import { Component, HostBinding, Input } from '@angular/core';
import { IActionButton } from '../../models';

@Component({
  selector: 'bkui-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent {
  @HostBinding('style.--height') @Input() height = 1;
  @HostBinding('style.--width') @Input() width = 1;
  @Input() title?: string;
  @Input() actions: IActionButton[] = [];
}
